import { NavigationMenu, NavigationMenuList } from '@kit/ui/navigation-menu';
import { Trans } from '@kit/ui/trans';

import { MobileSiteNavigation } from './mobile-site-navigation';
import { SiteNavigationItem } from './site-navigation-item';

// Blog, Changelog, Documentation, FAQ and Pricing are deliberately absent.
// Those routes still exist and still serve Makerkit's demo content; linking
// them from a Concierge site would advertise someone else's starter kit. The
// only nav entry left is Sign In. Self-serve sign-up is deliberately absent:
// accounts are provisioned after a demo, not created by visitors.
const links = {
  SignIn: {
    label: 'auth.signIn',
    path: '/auth/sign-in',
    showOn: 'mobile',
  },
};

export function SiteNavigation() {
  const NavItems = Object.values(links)
    .map((item) => {
      if ('showOn' in item && item.showOn === 'mobile') return null;

      return (
        <SiteNavigationItem key={item.path} path={item.path}>
          <Trans i18nKey={item.label} />
        </SiteNavigationItem>
      );
    })
    .filter(Boolean);

  return (
    <>
      <div className={'hidden items-center justify-center md:flex'}>
        <NavigationMenu>
          <NavigationMenuList className={'gap-x-2.5'}>
            {NavItems}
          </NavigationMenuList>
        </NavigationMenu>
      </div>

      <div className={'flex justify-start sm:items-center md:hidden'}>
        <MobileSiteNavigation links={Object.values(links)} />
      </div>
    </>
  );
}
